import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, batch } from 'react-redux';

import { SvgIcon } from '../../../../../../../../common/react/components/SvgIcon';
import { FULL_TABLE_CATEGORIES, FULL_TABLE_TABNAME } from '../../../../settings/full-table';
import { navLink } from '../../../../utils/nav-link';
import { Card } from '../../../Card/Card';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { STATS } from '../../../StatsLeaders/config/stats';
import { UPDATE_FILTER_ITEM, UPDATE_NAV_ITEM, UPDATE_SORT } from '../../../../../../store/js/modules/statspro/stats-leaders/actions';
import { TeamWatermarkBackground } from '../../../TeamWatermarkBackground';

/**
 * @param {object} props - Props.
 * @param {array} props.players - Player details.
 * @param {string} props.compseasonId - Compseason ID.
 * @returns {JSX.Element} Component.
 */
export const SeasonLeadersCard = ( { players, compseasonId } ) => {
    const dispatch = useDispatch();
    const [ firstPlayer, ...otherPlayers ] = players;
    const fullTableInfo = FULL_TABLE_CATEGORIES[ firstPlayer.category ];
    const translations = {
        category: STATS[ fullTableInfo.column ].name,
        perGame: getTranslation( 'label.statspro.perGame' ),
        fullTable: getTranslation( 'label.statspro.fullTable' )
    };

    const linkToFullTable = ( ) => {
        batch( () => {
            dispatch( UPDATE_NAV_ITEM.request( {
                navItem: 'category',
                value: fullTableInfo.category
            } ) );

            dispatch( UPDATE_NAV_ITEM.request( {
                navItem: 'season',
                value: { id: parseInt( compseasonId ) }
            } ) );

            dispatch( UPDATE_NAV_ITEM.request( {
                navItem: 'round',
                value: { id: -1, number: 0 }
            } ) );

            dispatch ( UPDATE_SORT.request( {
                columnId: fullTableInfo.column,
                sortDirection: 'descending'
            } ) );
        
            dispatch( UPDATE_FILTER_ITEM.request( {
                filterItem: 'teams',
                value: []
            } ) );

            dispatch( UPDATE_FILTER_ITEM.request( {
                filterItem: 'positions',
                value: []
            } ) );
        } );

        navLink( FULL_TABLE_TABNAME );
    };

    return (
        <Card>
            <div className={ 'statspro-card-featured-player' }>
                <div className="statspro-card-featured-player__inner-container">
                    <TeamWatermarkBackground
                        teamAbbreviation={ firstPlayer.team.teamAbbr }
                        className="statspro-card-featured-player__bg statspro-card-featured-player__bg--no-border-radius-bottom"
                    />
                    <div className="statspro-card-featured-player__category-container">
                        <p className="statspro-card-featured-player__category">{ translations.category }</p>
                    </div>
                    <div className="statspro-card-featured-player__details">
                        <p className="statspro-card-featured-player__value">
                            { firstPlayer.value }
                            { firstPlayer.type === 'SEASON_AVERAGE' ? (
                                <span> { translations.perGame }</span>
                            ) : '' }
                        </p>
                        <div className="statspro-card-featured-player__details-bottom">
                            <p className="statspro-card-featured-player__name">
                                { firstPlayer.player.givenName } <span>{ firstPlayer.player.surname }</span>
                            </p>
                        </div>
                    </div>
                    <div className="statspro-card-featured-player__photo-container">
                        <img className="statspro-card-featured-player__image" src={ firstPlayer.player.photoURL.split( '?' )[ 0 ] } />
                    </div>
                </div>
            </div>

            <div className="season-leaders__players-table-container">
                { otherPlayers.map( ( player, i ) => {
                    return (
                        <div key={ i } className={ 'season-leaders__player team-' + player.team.teamAbbr.toLowerCase() }>
                            <div className="season-leaders__photo-container">
                                <img className="season-leaders__image" src={ player.player.photoURL.split( '?' )[ 0 ] } />
                            </div>
                            <div className="season-leaders__name">
                                { player.player.givenName } <span>{ player.player.surname }</span>
                            </div>
                            <div className="season-leaders__value">
                                { player.value }
                            </div>
                        </div>
                    );
                } ) }

                <div className="season-leaders__link-container">
                    <button
                        className='season-leaders__link'
                        onClick={ () => linkToFullTable() }
                    >
                        { translations.fullTable }
                        <span className="season-leaders__link-icon">
                            <SvgIcon
                                icon="arrow-right"
                                className='icon'
                            />
                        </span>
                    </button>
                </div>
            </div>
        </Card>
    );
};

SeasonLeadersCard.propTypes = {
    players: PropTypes.array.isRequired,
    compseasonId: PropTypes.string.isRequired
};